import React from "react";
import { Wrapper, TitleContainer, Title } from "./styled";
import ContributorInputs from "./components/ContributorInputs";
import { DATA_TAXPAYER } from "../../constants";
import Description from "../../components/Description";

const ContributorForm = () => {
  return (
    <Wrapper>
      <TitleContainer>
        <Title>{DATA_TAXPAYER}</Title>
        <Description text="Persona o entidad obligada al pago de las tasas" />
      </TitleContainer>
      <ContributorInputs />
    </Wrapper>
  );
};

export default ContributorForm;
